"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Clock, Shield, TrendingUp, Zap, Users, CircleCheck } from "lucide-react";
export default function WarumUnsereKiLosungIhrBusinessTransformiert() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const benefits = [{
    icon: Clock,
    title: "24/7 Erreichbarkeit"
  }, {
    icon: Shield,
    title: "Professioneller erster Eindruck"
  }, {
    icon: TrendingUp,
    title: "Kostenersparnis durch Automatisierung"
  }, {
    icon: Zap,
    title: "Keine verpassten Anrufe mehr"
  }, {
    icon: Users,
    title: "Effiziente Ressourcen-Nutzung"
  }, {
    icon: CircleCheck,
    title: "Kontinuierliche Lernfähigkeit"
  }];
  return <section className="bg-dark-background py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <div ref={ref} className={`transition-all duration-[var(--duration-medium)] ease-[var(--ease-out)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-2.5"}`}>
          <h2 className="text-foreground-dark text-3xl md:text-4xl lg:text-5xl font-display font-bold text-center mb-12 md:mb-16">
            Warum unsere KI-Lösung Ihr Business transformiert
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
            {benefits.map((benefit, i) => {
            const Icon = benefit.icon;
            return <Card key={i} data-index={i} className="bg-background shadow-soft hover:shadow-medium hover:-translate-y-1 transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] group border-b-2 border-b-transparent hover:border-b-primary px-6">
                  <CardHeader className="pb-4">
                    <div className="flex items-center justify-center w-12 h-12 rounded-md bg-primary-light mb-4">
                      <Icon className="w-6 h-6 text-primary" strokeWidth={2} />
                    </div>
                  </CardHeader>
                  <CardContent className="pb-6">
                    <CardTitle className="text-foreground text-lg font-semibold">
                      {benefit.title}
                    </CardTitle>
                  </CardContent>
                </Card>;
          })}
          </div>
        </div>
      </div>
    </section>;
}